export default __webpack_public_path__ + "static/media/tanner.ba9c8b04.png";